import { deleteCookie, getCookie, setCookie } from './cookie-reader';

export function updateLastSiteIdCookie(cookieValue: string | number): void {
  setCookie('ABD1F88FED3A461FBA8796E0C68F69FD', cookieValue);
}

export function updateDateFormatCookie(cookieValue: string | number): void {
  setCookie('E778864F94F94C318242045395455149', cookieValue);
}

export function updateLanguageIdCookie(cookieValue: string | number): void {
  setCookie('36EB586E8D3A4C9FB40C10D86B49EE98', cookieValue);
}

export function updateDelimiterTypeCookie(cookieValue: string | number): void {
  setCookie('D3A4C9FB40C10D86B49EE9836EB586E8', cookieValue);
}

export function updateUserIdCookie(cookieValue: string | number): void {
  setCookie('7BA02437128B4F328A80DF78676E65E0', cookieValue);
}

export function updateEnvironmentFullURLCookie(cookieValue: string | number): void {
  setCookie('E9A21238833049C3907623DD86D2E732', cookieValue);
}

export function updateProductAPITokenCookie(cookieValue: string | number): void {
  setCookie('EE3B69BC-D275-4D89-ACCD-D91136DAD45C', cookieValue);
}

export function updateIntegrationAPITokenCookie(cookieValue: string | number): void {
  setCookie('2906AC24C7324A2EA1BC2FF27CB08F9A', cookieValue);
}

export function updateIntegrationAPIURLCookie(cookieValue: string | number): void {
  setCookie('F446E9D07E364203B3DCD9590D559A02', encodeURIComponent(cookieValue));
}

export function updateReloadSessionCookie(cookieValue: string | number): void {
  setCookie('5E32D867A42C48358F909F85F78056CE', cookieValue);
}

export function updateIdleTimeoutCookie(cookieValue: string | number): void {
  setCookie('399E3DB191D941ACA3B84EBD5B69F167', cookieValue);
}

const LEGACY_LAST_ACCESS_COOKIE = 'A9673308967047B883713587A240F0DF';

export function formatLegacyLastAccessCookieValue(date: Date): string {
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');

  return encodeURIComponent(`${day}/${month}/${year} ${hours}:${minutes}:${seconds}`);
}

export function updateLastAccessCookie(cookieValue: Date): void {
  setCookie(LEGACY_LAST_ACCESS_COOKIE, formatLegacyLastAccessCookieValue(cookieValue));
}

export function syncLegacySessionCookies(accessToken?: string): void {
  if (accessToken) {
    updateProductAPITokenCookie(accessToken);
  }
  updateLastAccessCookie(new Date());
}

export function updateBookmarkAPIUrlCookie(cookieValue: string | number): void {
  setCookie('11B105E6-4058-4612-849D-8EEDF634FF1E', cookieValue);
}

export function updateDocumentAPIUrlCookie(cookieValue: string | number): void {
  setCookie('A5114064-A94D-4B9F-8E58-C1F37F854F19', cookieValue);
}

export function updateNotificationAPIUrlCookie(cookieValue: string | number): void {
  setCookie('D15593BF-75C0-4288-802A-FADB1F04AD4C', cookieValue);
}

export function updateAuthenticationAPIUrlCookie(cookieValue: string | number): void {
  setCookie('FF08A2A8-3AB1-4080-B735-19F4192DD884', cookieValue);
}

export function updateHashtagAPIUrlCookie(cookieValue: string | number): void {
  setCookie('212471D9-6ABD-4193-B278-1BE0BB2CFD79', cookieValue);
}

export function updatePraiseAPIUrlCookie(cookieValue: string | number): void {
  setCookie('B6BA4E5C-130F-48F3-9703-4A4FA6C5C371', cookieValue);
}

export function updateReactionAPIUrlCookie(cookieValue: string | number): void {
  setCookie('5DEE69EA-97B9-4323-81BF-F3C932986859', cookieValue);
}

export function updateCommentsAPIUrlCookie(cookieValue: string | number): void {
  setCookie('5F222681-52F4-4E64-A5A6-EE6475A1DDCB', cookieValue);
}

export function updateActionPlanAPIUrlCookie(cookieValue: string | number): void {
  setCookie('CCE63EEF-DAE0-4CF7-B8F2-10FB9115DDF6', cookieValue);
}

export function updateChecklistAPIUrlCookie(cookieValue: string | number): void {
  setCookie('260B3A2F-54E8-4C74-8ADE-19DFBCADDEF4', cookieValue);
}

export function updateCilAPIUrlCookie(cookieValue: string | number): void {
  setCookie('793D1C4D-467F-4B6F-9604-135F3E39710B', cookieValue);
}

export function updateDefectTagAPIUrlCookie(cookieValue: string | number): void {
  setCookie('9F922998-2C18-48FE-8F95-B8AF93E70347', cookieValue);
}

export function updateAdministrationAPIUrlCookie(cookieValue: string | number): void {
  setCookie('EC53C247-61C3-4BEA-ACBB-CB280D204A22', cookieValue);
}

export function updateCommentManagerAPIUrlCookie(cookieValue: string | number): void {
  setCookie('0FEBDDC3-F01B-471F-BC0D-E0C90D10D26C', cookieValue);
}

export function updateMultilingualAPIUrlCookie(cookieValue: string | number): void {
  setCookie('BE51A3FB-50C1-4DD7-9C63-E6FF2EDE577E', cookieValue);
}

export function updateSubtitleAPIUrlCookie(cookieValue: string | number): void {
  setCookie('717D88EB-7E62-401B-9C66-29002297FDC4', cookieValue);
}

export function updateCopilotAPIUrlCookie(cookieValue: string | number): void {
  setCookie('BF121791-4587-4D42-9160-8470DF7B9EED', cookieValue);
}

export function updateCloudFrontPolicyCookie(cookieValue: string): void {
  setCookie('CloudFront-Policy', cookieValue, { cookieDomain: '.solvacelabs.com' });
  setCookie('env-CloudFront-Policy', cookieValue);
}

export function updateCloudFrontSignatureCookie(cookieValue: string): void {
  setCookie('CloudFront-Signature', cookieValue, { cookieDomain: '.solvacelabs.com' });
  setCookie('env-CloudFront-Signature', cookieValue);
}

export function updateCloudFrontKeyPairIdCookie(cookieValue: string): void {
  setCookie('CloudFront-Key-Pair-Id', cookieValue, { cookieDomain: '.solvacelabs.com' });
  setCookie('env-CloudFront-Key-Pair-Id', cookieValue);
}

export function updateAlertBarCookie(cookieValue: string | number): void {
  setCookie('04AFC2CD-6149-4A16-8266-1D8D97BF1547', cookieValue);
}

export function getAlertBarCookie(): string {
  return getCookie('04AFC2CD-6149-4A16-8266-1D8D97BF1547');
}

export function updateModuleIntegrationAPIUrlCookie(cookieValue: string | number): void {
  setCookie('23A23ADF-20EA-467D-8BEA-E150C51B39D7', cookieValue);
}

export function deleteLegacyCookies(except?: string[]): void {
  except = except ?? [];
  const cookiesToDelete: (string | { cookie: string; domain: string })[] = [
    'ABD1F88FED3A461FBA8796E0C68F69FD',
    'E778864F94F94C318242045395455149',
    '36EB586E8D3A4C9FB40C10D86B49EE98',
    '7BA02437128B4F328A80DF78676E65E0',
    'E9A21238833049C3907623DD86D2E732',
    '2906AC24C7324A2EA1BC2FF27CB08F9A',
    'F446E9D07E364203B3DCD9590D559A02',
    '5E32D867A42C48358F909F85F78056CE',
    '399E3DB191D941ACA3B84EBD5B69F167',
    'A9673308967047B883713587A240F0DF',
    'D3A4C9FB40C10D86B49EE9836EB586E8',
    'EE3B69BC-D275-4D89-ACCD-D91136DAD45C',
    '11B105E6-4058-4612-849D-8EEDF634FF1E',
    'A5114064-A94D-4B9F-8E58-C1F37F854F19',
    'D15593BF-75C0-4288-802A-FADB1F04AD4C',
    'FF08A2A8-3AB1-4080-B735-19F4192DD884',
    '212471D9-6ABD-4193-B278-1BE0BB2CFD79',
    'B6BA4E5C-130F-48F3-9703-4A4FA6C5C371',
    '5DEE69EA-97B9-4323-81BF-F3C932986859',
    '5F222681-52F4-4E64-A5A6-EE6475A1DDCB',
    'CCE63EEF-DAE0-4CF7-B8F2-10FB9115DDF6',
    '260B3A2F-54E8-4C74-8ADE-19DFBCADDEF4',
    '793D1C4D-467F-4B6F-9604-135F3E39710B',
    '9F922998-2C18-48FE-8F95-B8AF93E70347',
    'EC53C247-61C3-4BEA-ACBB-CB280D204A22',
    '0FEBDDC3-F01B-471F-BC0D-E0C90D10D26C',
    'BE51A3FB-50C1-4DD7-9C63-E6FF2EDE577E',
    '717D88EB-7E62-401B-9C66-29002297FDC4',
    '04AFC2CD-6149-4A16-8266-1D8D97BF1547',
    'BF121791-4587-4D42-9160-8470DF7B9EED',
    '23A23ADF-20EA-467D-8BEA-E150C51B39D7',
    { cookie: 'CloudFront-Signature', domain: '.solvacelabs.com' },
    { cookie: 'CloudFront-Policy', domain: '.solvacelabs.com' },
    { cookie: 'CloudFront-Key-Pair-Id', domain: '.solvacelabs.com' },
    'env-CloudFront-Signature',
    'env-CloudFront-Policy',
    'env-CloudFront-Key-Pair-Id',
  ];

  cookiesToDelete.forEach((cookie) => {
    if (!cookie) return;
    try {
      const cookieName = typeof cookie === 'string' ? cookie : cookie.cookie;
      const cookieDomain = typeof cookie === 'string' ? null : cookie.domain;
      if (!except.includes(cookieName)) {
        deleteCookie(cookieName, cookieDomain ? { domain: cookieDomain } : null);
      }
    } catch (e) {
      console.error(e);
    }
  });
}

